import { BrandName, useBrandConfig } from '@40seas/frontend/libs/providers';
import * as React from 'react';
import { Logo40SeasRow } from '../../../../assets/Logo40seasRow';
import { Logo40seasColumn } from '../../../../assets/Logo40seasColumn';
import { LogoReevolRow } from '../../../../assets/LogoReevolRow';
import { LogoReevolColumn } from '../../../../assets/LogoReevolColumn';

interface BrandLogoProps {
    variant?: 'row' | 'column';
    style?: React.CSSProperties;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({ variant = 'row', style }) => {
    const brandConfig = useBrandConfig();

    if (brandConfig.name === BrandName.Reevol) {
        return variant === 'row' ? <LogoReevolRow style={style} /> : <LogoReevolColumn style={style} />;
    }

    return variant === 'row' ? <Logo40SeasRow style={style} /> : <Logo40seasColumn style={style} />;
};
